import {onFind} from "@elements/init-modules-in-scope";
import {on} from "@elements/dom-utils";

const selectors = {
    select: '.js-select-load-url',
};

export function init() {
    onFind(selectors.select, function (loadUrl) {
        on('change', function (e) {

            let url = e.target.value;
            if (url) {
                window.location = url;
            }
        }, loadUrl);
    });
}